



































import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  name: 'PerformanceWidgetSimpleContent',
  components: {
  },
})
export default class PerformanceWidgetSimpleContent extends Vue {
  @Prop({ default: '' }) protected unit!: string;

  @Prop({ default: '$' }) protected sign!: string;

  @Prop({ default: false }) protected inverseCompareColor!: boolean;

  @Prop() protected value!: any;

  @Prop() protected currency!: string;

  @Prop() protected type!: string;

  @Prop() protected difference!: any;

  @Prop() protected compare!: any;

  @Prop() protected yourValue!: any;
}
